import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import renderEditor from '../../../shared/components/text-editor/TextEditor';
import { Field, reduxForm } from 'redux-form';

const EditorCard = () => (
  <Col md={12} lg={12}>
    <Card>
      <CardBody>
        <Field
          name='body'
          component={renderEditor}
        />
      </CardBody>
    </Card>
  </Col>
);

export default reduxForm({
  form: 'article',
  destroyOnUnmount: false
})(EditorCard);
